
const langData={
    "en_US":{
        appName:"Suixinliao",
        home:"Home",
        about:"About",
        download:"Download",
        theme:{
            title:"",
            desc:"Chat with friends anytime, anywhere<br/>Exchange voice and video calls"
        },
        model1:{
            title:"Messaging is fast, secure and encrypted",
            desc:"Your privacy is our top priority. With end-to-end encryption, you can ensure your personal messages are visible only to you and the recipient."
        },
        model2:{
            title:"Converse freely",
            desc: "End-to-end encryption makes your personal messages and calls more secure. Only the person you are talking to and you can read or listen to the message content. Beyond that, no one else (even Suixinliao) can There's no way to know.",
            li01:{
                title:"Free",
                title:"Suixinliao provides free and secure messaging."
            },
            li02:{
                title:"Safety",
                title:"Xpress Chat protects your messages from hacker attacks."
            },
            li03:{
                title:"Quick",
                title:"Deliver messages faster than any other app."
            },
            li04:{
                title:"Privacy",
                title:"Suixinliao adopts end-to-end coding."
            },
            li05:{
                title:"Anti-eavesdropping",
                title:"Use trunk calling technology to encrypt communications and ensure the security of your IP information."
            },
            li06:{
                title:"Simple",
                title:"Chat is easy, you already know how to use it."
            }
        },
        model3:{
            title:"Make voice and video calls<br>share each other's wonderful world",
            desc:"Share your wonderful world. Send photos and files, voice and video calls, no matter how big or small. Get grandma's secret recipes in the blink of an eye."
        },
        model4:{
            title:"Use groups to stay connected",
            desc:"Stay connected with the groups you're closest to with simple group and community messaging."
        },
        model5:{
            title:"Download and chat",
            desc: "Use Xixin Chat on multiple devices to continue communicating, and the conversation never stops"
        },
        footer:{
            desc:"A cloud-based mobile messaging app focused on security and speed.",
             privacy:"Privacy Terms",
             clientAgreement:"Client Agreement"
        }
    },
    "zh_CN":{
        appName:"随心聊",
        home:"首页",
        about:"关于",
        download:"下载",
        theme:{
            title:"",
            desc:"随时随地和好友聊天<br/>互发语音以及视频通话"
        },
        model1:{
            title:"消息传递快速安全且加密",
            desc:"您的隐私是我们的头等大事。借助端到端加密技术，您可以确保您的个人消息只有您和接收人才能看到。"
        },
        model2:{
            title:"自由自在地交谈",
            desc:"端到端加密让你的个人消息和通话更有安全保障。只有与您交谈的人和您自己可以读取或收听消息内容。除此之外，其他任何人（甚至包括Suixinliao）都无法得知。",
            li01:{
                title:"免费",
                title:"随心聊提供免费且安全消息传递。"
            },
            li02:{
                title:"安全",
                title:"随心聊保护您的消息描述黑客攻击。"
            },
            li03:{
                title:"快速的",
                title:"传递消息的速度比任何其他应用程序都快。"
            },
            li04:{
                title:"隐私",
                title:"随心聊采用端对端加码。"
            },
            li05:{
                title:"防窃听",
                title:"使用中继线呼叫技术加密通信，确保您的IP信息安全。"
            },
            li06:{
                title:"简单的",
                title:"随心聊非常简单，您已经知道如何使用它。"
            }
        },
        model3:{
            title:"拨通语音和视频通话<br>分享彼此的精彩世界",
            desc:"分享您的精彩世界。 发送照片和文件、语音和视频通话，不限大小。 眨眼间即可获得奶奶的秘方。"
        },
        model4:{
            title:"利用群组，保持联络",
            desc:"通过简单的群组和社群信息，与关系最密切的群组保持联系。"
        },
        model5:{
            title:"下载随心聊",
            desc:"在多个设备使用随心聊持续沟通交流，对话从不间断"
        },
        footer:{
            desc:"一款基于云的移动消息传递应用程序，注重安全性和速度。",
            privacy:"隐私条款",
            clientAgreement:"客户协议"
        }
    }
}

export  {langData};